// Premium glass tooltip for recharts
export const ChartTooltip = ({ active, payload, label, formatter, labelFormatter }) => {
  if (!active || !payload || !payload.length) return null;
  return (
    <div className="rounded-2xl glass-strong card-shadow-lg px-3 py-2">
      <div className="mb-1 text-xs font-semibold text-foreground">
        {labelFormatter ? labelFormatter(label) : label}
      </div>
      <div className="space-y-0.5">
        {payload.map((p, i) => (
          <div key={i} className="flex items-center gap-2 text-xs">
            <span className="inline-block h-2 w-2 rounded-full" style={{ background: p.color || p.stroke || p.fill }} />
            <span className="text-muted-foreground">{p.name}</span>
            <span className="ml-auto font-medium tabular text-foreground">
              {formatter ? formatter(p.value, p.name, p) : p.value}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
